/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MappingWrite } from '../models/MappingWrite'
import type { paginationLinks } from '../models/paginationLinks'
import type { paginationMeta } from '../models/paginationMeta'
import type { Saml2MappingResource } from '../models/Saml2MappingResource'

import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'

export class SsoSamlRoleMappingService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * List Mappings.
     * @returns any OK
     * @throws ApiError
     */
    public getMappings({
        tenantId,
        page
    }: {
        tenantId: number
        /**
         * The page to retrieve starting with page 1.
         */
        page?: number
    }): CancelablePromise<{
        data: Array<Saml2MappingResource>
        meta: paginationMeta
        links: paginationLinks
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/saml2/tenant/{tenantId}/mapping',
            path: {
                tenantId: tenantId
            },
            query: {
                page: page
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Create a Mappings.
     * Name must be unique for each tenant.
     * @returns any Created
     * @throws ApiError
     */
    public createMapping({
        tenantId,
        requestBody
    }: {
        tenantId: number
        requestBody?: MappingWrite
    }): CancelablePromise<{
        data: Saml2MappingResource
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/saml2/tenant/{tenantId}/mapping',
            path: {
                tenantId: tenantId
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Show a single Mappings.
     * @returns any OK
     * @throws ApiError
     */
    public getMapping({
        tenantId,
        id
    }: {
        tenantId: number
        /**
         * ID of the retrieved resource.
         */
        id: number
    }): CancelablePromise<{
        data: Saml2MappingResource
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/saml2/tenant/{tenantId}/mapping/{id}',
            path: {
                tenantId: tenantId,
                id: id
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }

    /**
     * Delete a Mappings.
     * @returns void
     * @throws ApiError
     */
    public deleteMapping({
        tenantId,
        id
    }: {
        tenantId: number
        /**
         * ID of the retrieved resource.
         */
        id: number
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/saml2/tenant/{tenantId}/mapping/{id}',
            path: {
                tenantId: tenantId,
                id: id
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }

    /**
     * Update Mappings.
     * @returns any OK
     * @throws ApiError
     */
    public updateMapping({
        tenantId,
        id,
        requestBody
    }: {
        tenantId: number
        /**
         * ID of the retrieved resource.
         */
        id: number
        requestBody?: MappingWrite
    }): CancelablePromise<{
        data: Saml2MappingResource
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/saml2/tenant/{tenantId}/mapping/{id}',
            path: {
                tenantId: tenantId,
                id: id
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }
}
